import { ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';

import { environment } from '@environments/environment';
import * as merchantsReducer from './merchants.reducer';
import * as usersReducer from './users.reducer';

export interface State {
    merchants: merchantsReducer.State;
    users: usersReducer.State;
}

export const reducers: ActionReducerMap<State> = {
    merchants: merchantsReducer.reducer,
    users: usersReducer.reducer
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];

export const selectMerchantsState = createFeatureSelector<State>('super-admin');
export const selectUsersState = createFeatureSelector<State>('super-admin');
export const selectMerchants = createSelector(selectMerchantsState, state => state.merchants);
export const selectUsers = createSelector(selectUsersState, state => state.users);

export const getMerchants = createSelector(selectMerchants, merchantsReducer.getMerchants);
export const getUsers = createSelector(selectUsers, usersReducer.getUsers);
export const getMerchantsSuccess = createSelector(selectMerchants, merchantsReducer.getMerchantsSuccess);
export const getMerchantsPending = createSelector(selectMerchants, merchantsReducer.getMerchantsPending);
export const getMerchantsError = createSelector(selectMerchants, merchantsReducer.getMerchantsError);

